import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import EntityExampleWrapper from 'client/components/core/EntityExampleWrapper'
import { useIsShowAdditionalAction } from 'client/hooks/use-is-show-additional-action'
import { usePage, usePayment } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import paymentSelectors from 'client/store/payment/paymentSelectors'
import CommonPaymentMethod from 'common/components/entities/PaymentMethodNew'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import React from 'react'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'

interface PaymentMethodProps {
  entity: PaymentMethodInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}
function PaymentMethod({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: PaymentMethodProps) {
  const paymentMethods = usePayment(paymentSelectors.getPaymentMethods)
  const {
    text: { paragraphTextColor },
  } = useThemeColor()
  const isExample = paymentMethods.length === 0

  const calculatedMethods = isExample
    ? [PaymentMethodEnum.StripeCard, PaymentMethodEnum.PaypalSoap]
    : paymentMethods.filter(pm => Object.values(PaymentMethodEnum).includes(pm))

  const entityParents = usePage(page =>
    pageSelectors.getEntityParents(page.entities, entity),
  )

  const isShowAdditionalAction = useIsShowAdditionalAction({
    entityParents,
    entity,
  })

  return (
    <BaseEntity
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
      isSaveAllowed={isShowAdditionalAction}
      isRemoveAllowed={isShowAdditionalAction}
      isCopyAllowed={isShowAdditionalAction}
    >
      <EntityExampleWrapper
        label="entities.payment_methods.example_warning"
        visible={isExample}
      >
        <CommonPaymentMethod
          fontSize={entity.fontSize}
          mobileFontSize={entity.mobileFontSize}
          lineHeight={entity.lineHeight}
          mobileLineHeight={entity.mobileLineHeight}
          fontFamily={entity.fontFamily}
          fontWeight={entity.fontWeight}
          fontStyle={entity.fontStyle}
          mobileFontStyle={entity.mobileFontStyle}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontWeight={entity.mobileFontWeight}
          color={entity.color || paragraphTextColor}
          mobileColor={entity.mobileColor || paragraphTextColor}
          activeMethod={calculatedMethods[0] as PaymentMethodEnum} // stripe first
          paymentMethods={calculatedMethods as PaymentMethodEnum[]}
          attrId={entity.htmlAttrId}
        />
      </EntityExampleWrapper>
    </BaseEntity>
  )
}

export default PaymentMethod
